import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  gap: 2rem;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;

  margin-top: var(--metrics-m);
  margin-bottom: var(--metrics-xl);
`;

export const NavWrapper = styled.nav`
  width: 100%;
  display: flex;

  justify-content: space-between;
  align-items: center;
`;
